// import { AppSidebar } from '@/components/app-sidebar';
// import Header from '@/components/Header';
// import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
// import { Outlet } from 'react-router-dom';

// const AppLayout = () => {
//   return (
//     <SidebarProvider>
//       <div className="flex h-screen w-full overflow-hidden">
//         {/* Sidebar */}
//         <AppSidebar />

//         {/* Main area */}
//         <SidebarInset className="flex h-full flex-col bg-secondary">
//           {/* Header (fixed height) */}
//           <Header />

//           {/* Main scroll area */}
//           <main className="flex-1 overflow-y-auto p-6 pt-0">
//             <Outlet />
//           </main>
//         </SidebarInset>
//       </div>
//     </SidebarProvider>
//   );
// };

// export default AppLayout;

// src/layouts/AppLayout.tsx
import { AppSidebar } from '@/components/app-sidebar';
import Header from '@/components/Header';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { Outlet } from 'react-router-dom';

const AppLayout = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full overflow-hidden">
        {/* Sidebar */}
        <AppSidebar />

        {/* Main area - Added min-w-0 to allow shrinking */}
        <SidebarInset className="flex h-full min-w-0 flex-1 flex-col bg-secondary">
          {/* Header (fixed height) */}
          <Header />

          {/* Main scroll area - Added min-w-0 and overflow-x-hidden */}
          <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-6 pt-0">
            <div className="min-w-0">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AppLayout;
